// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Headsets from './Headsets';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Headsets);
